module.exports = __webpack_public_path__ + "img/ipad.82803b37.png";